import request from '@/utils/request'

/**
 * 获取币种列表
 * @param {Object} data
 * @returns
 */
export function getCurrencyList(data) {
  return request({
    url: '/mg/drp-enterprise-api/currency/list',
    method: 'post',
    data,
  })
}

/**
 * 获取集团=MG的所有法人公司列表
 * @param {Object} data
 * @returns
 */
export function getPayCompanyPage(data) {
  return request({
    url: '/mg/fee-api/corporateCompany/pageMGCorporateCompany',
    method: 'post',
    allowRepeat: true,
    data,
  })
}

/**
 * 获取费用类型列表
 * @param {*} params
 * @returns
 */
export function getFeeTypeListByReimburseTypeCodeNoControl(params) {
  return request({
    url: '/mg/ecs-api/basicData/feeType/queryByReimburseTypeCode/noControl',
    method: 'get',
    params,
  })
}

/**
 * 根据报账类型获取费用类型列表
 * @param {*} params
 * @returns
 */
export function getFeeTypeListByReimburseTypeCode(params) {
  return request({
    url: '/mg/ecs-api/basicData/feeType/queryByReimburseTypeCode',
    method: 'get',
    params,
  })
}

/**
 * 查询承担主体
 * @param {*} data
 * @returns
 */
export function queryByAdministrativeCode(params) {
  return request({
    url: '/mg/ecs-api/basicData/organization/queryByAdministrativeCode',
    method: 'get',
    params,
    allowRepeat: true,
  })
}

/**
 * 分页查询承担主体（按行政组织编码）
 * @param {*} data
 * @returns
 */
export function pageOrganizationByAdministrativeCode(data) {
  return request({
    url: '/mg/ecs-api/basicData/organization/pageByAdministrativeCode',
    method: 'post',
    data,
    allowRepeat: true,
  })
}

/**
 * 分页查询承担主体
 * @param {*} params
 * @returns
 */
export function queryOrganizationCodePage(data) {
  return request({
    url: '/mg/ecs-api/basicData/organization/page',
    method: 'post',
    data,
    allowRepeat: true,
  })
}

/**
 * 获取人员档案信息 -- 分页
 * @param {*} params
 * @returns
 */
export function getStaffPage(data) {
  return request({
    url: '/mg/drp-user-api/mdStaff/pageStaffList',
    method: 'post',
    data,
    allowRepeat: true,
  })
}
/**
 * 通过员工工号获取所属员工所属主体信息
 * @param {*} data
 * @returns
 */
export function postEmployeeInfoByStaffCode(data) {
  return request({
    url: '/mg/drp-user-api/employee/batchEmployee',
    method: 'post',
    data,
  })
}

/**
 * 根据员工获取门店信息
 * @param {*} params
 * @returns
 */
export function postStoresinfoByCodesLists(data) {
  return request({
    url: '/mg/drp-user-api/mdStaff/listStoresInfoByCodes',
    method: 'post',
    data,
  })
}

/**
 * 获取差旅标准列表
 * @param {*} data
 * @returns
 */
export function getTravelStandardsList(data) {
  return request({
    url: '/mg/ecs-api/travelStandards/list',
    method: 'post',
    data,
  })
}

/**
 * 获取一条差旅标准
 * @param {*} data
 * @returns
 */
export function getTravelStandardsOne(data) {
  return request({
    url: '/mg/ecs-api/travelStandards/getTravelStandardsOne',
    method: 'post',
    data,
    allowRepeat: true,
  })
}

/**
 * 批量获取差旅标准
 * @param {*} data
 * @returns
 */
export function getBatchTravelStandards(data) {
  return request({
    url: '/mg/ecs-api/travelStandards/getTravelStandardsAndCity',
    method: 'post',
    data,
  })
}

/**
 *
 * @param {*} params
 * @returns
 */
export function postSupplierByFmsList(data) {
  return request({
    url: '/mg/fee-api/supplierRelation/queryByCodeOrNameSupplier',
    method: 'post',
    data,
  })
}

/**
 *
 * @param {*} params
 * @returns
 */
export function postSupplierByFmsPage(data) {
  return request({
    url: '/mg/fee-api/supplierRelation/pageByCodeOrNameSupplier',
    method: 'post',
    data,
    allowRepeat: true,
  })
}

// 通过付款公司编码获取银行账户 (目前已在还款单使用)
export function getByCorporateCompanyCodeAccountList(corporateCompanyCode) {
  return request({
    url: `/mg/fee-api/corporateCompanyAccount/queryByCorporateCompanyCode/${corporateCompanyCode}`,
    method: 'get',
  })
}

/**
 * 获取税率
 * @param {*} data
 * @returns
 */
export function getTaxItemsPage(data) {
  return request({
    url: '/mg/drp-enterprise-api/taxItems/page',
    method: 'post',
    data,
  })
}

/**
 * 通过供应商关系查询供应商关系的法人公司列表
 */
export function getCompanyListByRelation(data) {
  return request({
    url: '/mg/fee-api/corporateCompany/listBySupplierRelation',
    method: 'post',
    data,
  })
}

/**
 * 查询默认的承担主体
 */
export function getOrganizationDefault(params) {
  return request({
    url: '/mg/ecs-api/basicData/organization/default',
    method: 'get',
    params,
  })
}

// 默认列表查询 全部法人公司分页查询
export function getCorporateCompanyListDefault(data) {
  return request({
    url: '/mg/fee-api/corporateCompany/page',
    method: 'post',
    data,
  })
}

// 默认列表查询 全部法人公司分页查询分公司
export function corporateCompanyListDefault(data) {
  return request({
    url: '/mg/fee-api/corporateCompany/fmsAndDrpCustomer',
    method: 'post',
    data,
  })
}

// 默认列表查询 全部法人公司分页查询分公司DRP主数据同步到主数据中台ORG
export function fmsAndDrpCustomerListDefault(data) {
  return request({
    url: '/mg/fee-api/corporateCompany/fmsAndDrpCustomer',
    method: 'post',
    data,
  })
}

// 默认列表查询 全部法人公司分页查询
export function getPartner(id) {
  return request({
    url: `/mg/fee-api/partner/${id}`,
    method: 'get',
  })
}

/**
 * 预算查询
 */
export function budgetQuery(data) {
  return request({
    url: `/mg/ecs-api/budget/query`,
    method: 'post',
    data,
    loading: true,
  })
}

//获取关联的核销单
export function writeOffOrder(data) {
  return request({
    url: `/mg/ecs-api/writeOffOrder/getBillNo`,
    method: 'post',
    data,
  })
}

/**
 * 查询超标余额
 * @param {*} data
 * @returns
 */
export function fetchQuotaBalanceList(data) {
  return request({
    url: '/mg/ecs-api/quotaBalance/balanceQuery',
    method: 'post',
    data,
  })
}

/**
 * 查询合同列表信息
 * @param {*} data
 * @returns
 */
export function getContractList(data) {
  return request({
    url: '/mg/ecs-api/ecsReimburseContractRecord/getContractList',
    method: 'post',
    data,
  })
}

/**
 * 获取合同付款信息列表
 * @param {*} data
 * @returns
 */
export function getContractPaymentItemList(data) {
  return request({
    url: '/mg/ecs-api/ecsReimburseContractRecord/getContractPaymentItemList',
    method: 'post',
    data,
  })
}

/**
 * 获取合同跳转OA的地址
 * @param {*} data
 * @returns
 */
export function getOaUrl(data) {
  return request({
    url: '/mg/ecs-api/ecsContract/getOaUrl',
    method: 'post',
    data,
  })
}

/**
 * 获取申请单跳转OA的地址
 * @param {*} data
 * @returns
 */
export function getApplyOrderUrl(data) {
  return request({
    url: '/mg/ecs-api/applyOrder/url',
    method: 'post',
    data,
  })
}

//草稿态暂存
export function saveOrUpdateDraft(data) {
  return request({
    url: '/mg/ecs-api/draftOrder/saveOrUpdate',
    method: 'put',
    data,
    loading: true,
  })
}

//查询当前登录人下的草稿
export function getDraftDetail(id) {
  return request({
    url: `/mg/ecs-api/draftOrder/detail/${id}`,
    method: 'get',
    loading: true,
  })
}

/**
 * 保存草稿
 * @param {*} data
 * @returns
 */
export function saveDraft(data) {
  return request({
    url: '/mg/ecs-api/draftOrder/saveOrUpdate',
    method: 'put',
    loading: true,
    data,
  })
}

/**
 * 获取草稿详情
 * @param {*} draftOrderId
 * @returns
 */
export function getDraftDetailById(draftOrderId) {
  return request({
    url: `/mg/ecs-api/draftOrder/detail/${draftOrderId}`,
    method: 'get',
    loading: true,
  })
}

/**
 * 获取所有菜单地址
 * @param {*} params
 * @returns
 */
export function getPermissionsAllMenu(params) {
  return request({
    url: '/mg/drp-user-api/componentPermissionsMenu/list/all/v2',
    method: 'get',
    params,
  })
}

/**
 * 获取所有制度专栏
 * @param {*} params
 * @returns
 */
export function getInstitutional(data) {
  return request({
    url: '/mg/ecs-api/institutional/list',
    method: 'post',
    data,
  })
}

/**
 * 获取所有菜单地址
 * @param {*} params
 * @returns
 */
export function getShopPage(data) {
  return request({
    url: '/mg/fee-api/shop/page',
    method: 'post',
    data,
  })
}

/**
 * 获取赛道
 * @param {*} params
 * @returns
 */
export function costCategoryMenu(data) {
  return request({
    url: '/mg/ecs-api/costCategoryMenu/dict',
    method: 'post',
    data,
  })
}

/**
 * 获取用户
 * @param {*} params
 * @returns
 */
export function employeeSimplePage(data) {
  return request({
    url: '/mg/drp-user-api/employee/simplePage',
    method: 'post',
    data,
  })
}

/**
 * 获取费用类别
 * @param {*} params
 * @returns
 */
export function costCategoryList(data) {
  return request({
    url: '/mg/ecs-api/costCategory/order/list',
    method: 'post',
    data,
  })
}

/**
 * 获取推广方案申请单
 * @param {*} params
 * @returns
 */
export function pageOriginalPlanApplyOrder(data) {
  return request({
    url: '/mg/ecs-api/promotionOrder/pageOriginalPlanApplyOrder',
    method: 'post',
    data,
  })
}

/**
 * 获取第三方平台配置的平台列表
 * @param {*} params
 * @returns
 */
export function platformList(params) {
  return request({
    url: '/mg/ecs-api/thirdPartyConfig/platformList',
    method: 'get',
    params,
  })
}

/**
 * 获取第三方平台配置的店铺分页列表
 * @param {*} params
 * @returns
 */
export function storePage(params) {
  return request({
    url: '/mg/ecs-api/thirdPartyConfig/storePage',
    method: 'get',
    params,
  })
}

/**
 * 获取品类项目管控策略
 * @param {*} params
 * @returns
 */
export function batchDetail(data) {
  return request({
    url: '/mg/ecs-api/costCategoryMenu/batchDetail',
    method: 'post',
    data,
  })
}

/**
 * 查询推广单url跳转地址
 * @param {*} params
 * @returns
 */
export function promotionOrder(data) {
  return request({
    url: '/mg/ecs-api/promotionOrder/url',
    method: 'post',
    data,
  })
}
/**
 * 查询借款单url跳转地址
 * @param {*} params
 * @returns
 */
export function postDebtOrderUrl(data) {
  return request({
    url: '/mg/ecs-api/debtOrder/url',
    method: 'post',
    data,
  })
}

/**
 * 获取赛道品类类别
 * @param {*} params
 * @returns
 */
export function costCategoryMenuchildren(data) {
  return request({
    url: '/mg/ecs-api/costCategoryMenu/childrenNode',
    method: 'post',
    data,
    allowRepeat: true,
  })
}

/**
 * 根据费用类型获取预算项目列表
 * @param {*} params
 * @returns
 */
export function getfeeTypeBudgetProject(data) {
  return request({
    url: '/mg/budget-api/feeType/feeTypeBudgetProject/list',
    method: 'post',
    data,
  })
}

/**
 * 获取赛道品类类别
 * @param {*} params
 * @returns
 */
export function feeTypeBudgetProjectList(data) {
  return request({
    url: '/mg/budget-api/feeType/feeTypeBudgetProject/list',
    method: 'post',
    data,
    allowRepeat: true,
  })
}

/**
 * 根据月份+承担主体获取预算项目
 * @param {*} params
 * @returns
 */
export function budgetControlItemList(data) {
  return request({
    url: '/mg/budget-api/budgetControlItem/list',
    method: 'post',
    data,
    allowRepeat: true,
  })
}

/**
 * 附件列表查询
 * @param {*} params
 * @returns
 */
export function attachmentListQuery(data) {
  return request({
    url: '/mg/ecs-api/attachment/list',
    method: 'post',
    data,
  })
}

/**
 * 附件预览
 * @param {*} params
 * @returns
 */
export function attachmentPreview(data) {
  return request({
    url: '/mg/ecs-api/attachment/preview',
    method: 'post',
    data,
  })
}

/**
 * 附件预览查询支持的文件类型
 * @param {*} params
 * @returns
 */
export function querySupportFileTypes() {
  return request({
    url: '/mg/ecs-api/attachment/querySupportFileTypes',
    method: 'get',
  })
}

//折扣折让类型树
export function discountTypeTree(params) {
  return request({
    url: '/mg/drp-enterprise-api/discountType/new/treeWithAuditedItems',
    method: 'get',
    params,
  })
}

//折扣折让明细分页
export function discountTypePage(data) {
  return request({
    url: '/mg/drp-enterprise-api/discountTypeItem/pageVO',
    method: 'post',
    data,
  })
}

// 报销单关联发票
export function financialInvoiceAudit(data) {
  return request({
    url: '/mg/ecs-api/ecsInvoice/financialInspection',
    method: 'post',
    loading: true,
    data,
  })
}

//附件分类修改
export function attachmentCategorySave(data) {
  return request({
    url: '/mg/ecs-api/attachment',
    method: 'put',
    data,
    loading: true,
  })
}
